<template>
  <modal
    :headline="$t('msdsDocuments.downloadModal.headline')"
    class="ce-msdsDownloadModal"
    :class="{'ce-msdsDownloadModal--initialising': initialising}"
    @close="$emit('close')"
    :closable="!initialising && !loading">
    <div class="ce-modalContent">
      <div v-if="initialising">
        <fa-icon
          icon="spinner"
          spin />
      </div>
      <ValidationObserver
        ref="validationObserver"
        tag="div"
        v-else>
        <validated-select
          name="language"
          :label="$t('msdsDocuments.downloadModal.language')"
          :options="languages"
          v-model="selectedLanguage"
          rules="required"
          searchable />

        <validated-select
          name="type"
          :label="$t('msdsDocuments.downloadModal.type')"
          :options="types"
          v-model="selectedType"
          rules="required"
          searchable />

        <div>
          <button
            class="ce-btn ce-btn-light ce-btn--fullWidth"
            @click.prevent="submit"
            :disabled="loading">
            <template v-if="loading">
              <fa-icon
                icon="spinner"
                spin />
            </template>
            <template v-else>
              {{ $t('msdsDocuments.downloadModal.cta') }}
            </template>
          </button>
        </div>
      </ValidationObserver>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import MsdsDocumentService from 'services/MsdsDocumentService';

export default {
  props: {
    emg: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      initialising: true,
      loading: false,
      languages: null,
      types: null,
      selectedLanguage: 'Eng',
      selectedType: '',
    };
  },
  mounted() {
    this.fetchOptions();
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  methods: {
    async fetchOptions() {
      const { languages, types } = await MsdsDocumentService.getConfigOptions(this.token);
      this.languages = Object.fromEntries(languages.map((l) => [l.key, l.value]));
      this.types = Object.fromEntries(types.map((l) => [l.key, l.value]));
      this.initialising = false;
    },
    async submit() {
      const validationResult = await this.$refs.validationObserver.validate();
      if (!validationResult) return;
      this.loading = true;
      try {
        await MsdsDocumentService.triggerDownload(this.emg, this.selectedLanguage, this.selectedType, this.token);
        const noty = this.$notification.success(this.$t('msdsDocuments.downloadModal.successMessage'), {}, false);
        noty.show();

        this.loading = false;
        this.$emit('close');
      } catch (e) {
        this.loading = false;
        this.$notification.error(e.response?.data?.message ?? e.message);
      }
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-modal.ce-msdsDownloadModal {
  &--initialising {
    .ce-modalContent {
      display: flex;
      justify-content: center;
      .ms(5);
    }
  }

  .ce-modalInner {
    overflow: visible;
  }
  .ce-modalContent {
    span {
      text-decoration: none;
    }
  }
}
</style>
